import { __read } from "tslib";
import cx from 'classnames';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { WIDTH } from '../constants/handoffSidebar';
import resizeRootId from '../constants/resizeRootId';
import Banner from '../containers/Banner';
import ExitAnnotationMode from '../containers/ExitAnnotationMode';
import NavigationGrid from '../containers/NavigationGrid';
import OpenInMobile from '../containers/OpenInMobile';
import Player from '../containers/Player';
import Sidebar from '../containers/Sidebar';
import LayersPanel from '../containers/handoff/LayersPanel';
import SidebarHandoff from '../containers/handoff/SidebarHandoff';
import Zoom from '../containers/handoff/Zoom';
import AnnotationHint from './AnnotationHint';
import MadeWithMarvel from './MadeWithMarvel';
import styles from './Project.module.css';
import LayersButton from './handoff/LayersButton';
var HANDOFF_LAYERS_PREFERENCE = 'MARVEL_HANDOFF_LAYERS';
var LAYERS_ON = 'On';
var LAYERS_OFF = 'Off';
var Project = function (_a) {
    var _b;
    var onMobileDevice = _a.onMobileDevice, isEmbedded = _a.isEmbedded, isFrameless = _a.isFrameless, isBasic = _a.isBasic, isInTheExploreView = _a.isInTheExploreView, isPro = _a.isPro, showGridNav = _a.showGridNav, isInAnnotationMode = _a.isInAnnotationMode, isInHandoffMode = _a.isInHandoffMode, isDownloaded = _a.isDownloaded;
    var showSidebar = !onMobileDevice &&
        !isEmbedded &&
        !isInTheExploreView &&
        !isFrameless &&
        !isBasic;
    var showBanner = !isPro &&
        !(isEmbedded ||
            isInAnnotationMode ||
            isInTheExploreView ||
            isFrameless ||
            isBasic ||
            isDownloaded) &&
        !isInHandoffMode;
    var showHandoff = !isDownloaded && !isBasic;
    var showMadeWithMarvel = !isPro && !isInTheExploreView && isEmbedded;
    var projectClass = cx(styles.project, (_b = {},
        _b[styles.annotationMode] = isInAnnotationMode,
        _b[styles.handoffMode] = isInHandoffMode,
        _b.mobile = onMobileDevice,
        _b));
    var localPreference = localStorage.getItem(HANDOFF_LAYERS_PREFERENCE) === LAYERS_ON;
    var shouldShowLayersInitially = localStorage.getItem(HANDOFF_LAYERS_PREFERENCE) === null
        ? true
        : localPreference;
    var _c = __read(useState(shouldShowLayersInitially), 2), isShowingLayersPanel = _c[0], setSsShowingLayersPanel = _c[1];
    var onCloseLayersPanel = function () {
        setSsShowingLayersPanel(false);
        localStorage.setItem(HANDOFF_LAYERS_PREFERENCE, LAYERS_OFF);
    };
    var onOpenLayersPanel = function () {
        setSsShowingLayersPanel(true);
        localStorage.setItem(HANDOFF_LAYERS_PREFERENCE, LAYERS_ON);
    };
    var wrapperStyle = isInHandoffMode
        ? {
            paddingRight: WIDTH,
            paddingLeft: isShowingLayersPanel ? WIDTH : undefined,
        }
        : undefined;
    return (React.createElement("div", { className: projectClass, style: wrapperStyle },
        showSidebar && !showGridNav && (React.createElement(Sidebar, { isShowingLayersPanel: isShowingLayersPanel })),
        showGridNav ? (React.createElement(NavigationGrid, null)) : (React.createElement("div", { className: "height-100", id: resizeRootId },
            React.createElement(Player, null),
            showMadeWithMarvel && React.createElement(MadeWithMarvel, null),
            showBanner && React.createElement(Banner, { onMobileDevice: onMobileDevice }),
            !isEmbedded && React.createElement(OpenInMobile, null),
            isInAnnotationMode && React.createElement(ExitAnnotationMode, null),
            isInAnnotationMode && React.createElement(AnnotationHint, null),
            isInHandoffMode && React.createElement(Zoom, null),
            isInHandoffMode && !isShowingLayersPanel && (React.createElement(LayersButton, { onClick: onOpenLayersPanel })))),
        showHandoff && React.createElement(SidebarHandoff, null),
        isInHandoffMode && isShowingLayersPanel && (React.createElement(LayersPanel, { onClose: onCloseLayersPanel }))));
};
Project.propTypes = {
    onMobileDevice: PropTypes.bool,
    isEmbedded: PropTypes.bool,
    isInTheExploreView: PropTypes.bool,
    isPro: PropTypes.bool,
    showGridNav: PropTypes.bool,
    isInAnnotationMode: PropTypes.bool,
    isInHandoffMode: PropTypes.bool,
    isFrameless: PropTypes.bool,
    isBasic: PropTypes.bool,
    isDownloaded: PropTypes.bool,
};
export default Project;
